import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Typography
} from '@material-ui/core';
import React, { FC, memo, useCallback } from 'react';
import styled from 'styled-components';
import { viewTexts } from '../../../constants/view-texts';
import { MuiInput } from '../../shared/form-element';

const vt = viewTexts.dialogs.editProject;

const InputWrapper = styled.div`
  padding: 5px;
`;

interface Props {
  open: boolean;
  onClose: (reason: 'ok' | 'cancel' | '') => void;
  projectName: string | undefined;
  projectNameErrors: string[] | undefined;
  projectNameOnInput: (v: string) => void;
  submitButtonEnabled: boolean;
  nonFieldErrors: string[];
}

export const EditProjectDialogView: FC<Props> = memo(
  ({
    open,
    onClose,
    projectName = '',
    projectNameErrors = [],
    projectNameOnInput,
    submitButtonEnabled,
    nonFieldErrors
  }: Readonly<Props>) => {
    const onCloseByEscape = useCallback(() => {
      onClose('');
    }, [onClose]);

    const cancelOnClick = useCallback(() => {
      onClose('cancel');
    }, [onClose]);

    const okOnClick = useCallback(() => {
      onClose('ok');
    }, [onClose]);

    return (
      <Dialog open={open} onClose={onCloseByEscape}>
        <DialogTitle>{vt.title}</DialogTitle>
        <DialogContent>
          <Typography>{vt.description1}</Typography>
          <Typography>{vt.description2}</Typography>
          <InputWrapper>
            <MuiInput
              label={vt.label}
              required={true}
              value={projectName}
              onInput={projectNameOnInput}
              helperText={projectNameErrors.join(' ')}
              error={projectNameErrors.length > 0}
            />
          </InputWrapper>
          {nonFieldErrors.map((er, i) => (
            <FormHelperText key={i} error={true}>
              {er}
            </FormHelperText>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelOnClick} color='default'>
            {vt.cancel}
          </Button>
          <Button
            disabled={!submitButtonEnabled}
            onClick={okOnClick}
            color='primary'
            autoFocus={true}
          >
            {vt.ok}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

EditProjectDialogView.displayName = 'EditProjectDialogView';
